import { IGetSubcontasByIdUseCase } from "../../../presentation/useCases/read/get_subcontas_by_id_use_case";
import { Subconta } from "../../models/subconta";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetSubcontasByIdUseCase
 */

export class GetSubcontasByIdUseCase implements IGetSubcontasByIdUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(idSubconta: number): Promise<Subconta> {
    return this.repository.getSubcontaById(idSubconta);

  }
}
